import React from "react";
import "./CompanyStaff.css";
import data from "../../../data/data";
import Person from "./Person";
import { useTranslation } from "react-i18next";

const CompanyStaff = () => {
  // console.log("datas", data);
  const { t } = useTranslation();

  return (
    <div id="staff">
      {/* <h2 className="staffTitle">Meet our team</h2> */}
      <h2 className="staffTitle">{t("CompanyStaff/Text1")}</h2>
      <div className="person">
        {data.map((person) => {
          return <Person key={person.id} {...person} />;
        })}
      </div>
    </div>
  );
};

export default CompanyStaff;
